import React, { useEffect, useRef } from 'react';
import './Loader.css';
import { useConfig } from '../../../hooks/useConfig';

const Loader = ({ size = 'medium', fullPage = false, splash = false }) => {
  const emberRefs = useRef([]);
  const config = useConfig();
  
  useEffect(() => {
    if (splash) {
      // Set random movement values for each ember
      emberRefs.current.forEach(ember => {
        if (ember) {
          const randomX = Math.random() * 2 - 1; // Value between -1 and 1
          const randomRotate = Math.random() * 2 - 1; // Value between -1 and 1
          ember.style.setProperty('--random-x', randomX);
          ember.style.setProperty('--random-rotate', randomRotate);
        }
      });
    }
  }, [splash]);
  
  if (splash) {
    // Reset refs array
    emberRefs.current = [];
    
    return (
      <div className="splash-screen">
        <div className="splash-content">
          <img src={config.logo}className="splash-logo" />
          <div className="splash-text">
            <h1><span className="light">{config.name || 'Token'}</span> <span className="accent">BOT</span></h1>
            <p>Технологии, которые работают на тебя</p>
          </div>
        </div>
        
        {[...Array(60)].map((_, index) => (
          <div 
            key={index} 
            className="ember"
            ref={el => emberRefs.current[index] = el}
          ></div>
        ))}
      </div>
    );
  }
  
  const loaderClass = `loader loader-${size} ${fullPage ? 'loader-fullpage' : ''}`;
  
  return (
    <div className={loaderClass}>
      <div className="loader-spinner"></div>
    </div>
  );
};

export default Loader; 